<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M13.8718 5.87801L15.0718 7.07801L11.0051 11.1447L8.26348 8.40301C7.93848 8.07801 7.41348 8.07801 7.08848 8.40301L2.08848 13.4113C1.76348 13.7363 1.76348 14.2613 2.08848 14.5863C2.41348 14.9113 2.93848 14.9113 3.26348 14.5863L7.67181 10.1697L10.4135 12.9113C10.7385 13.2363 11.2635 13.2363 11.5885 12.9113L16.2468 8.26134L17.4468 9.46134C17.7051 9.71968 18.1551 9.53634 18.1551 9.16968V5.58634C18.1635 5.35301 17.9801 5.16968 17.7468 5.16968H14.1718C13.7968 5.16968 13.6135 5.61968 13.8718 5.87801Z"
      fill="#656C6F"
    />
  </svg>
</template>
